import { Box, Chip, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import RecordIcon from 'assets/icons/care-matrix-module/tabs/record/record.svg';
import { useIntl } from 'react-intl';

import { useCareMatrix } from 'hooks/useCareMatrix';
import { getPatientRecords } from 'services/user/user';

import { RecordItem } from './record-item';

import { RecordProps } from './types';

export function Record({ mustUpdate = false }: RecordProps) {
  const intl = useIntl();
  const { patientCognitoId } = useCareMatrix();

  const { data: records } = useQuery({
    queryFn: () => getPatientRecords(patientCognitoId),
    queryKey: ['getPatientRecords', patientCognitoId],
  });

  const hasRecords = records && records.questions.length > 0;

  return (
    <Box>
      <Box pt={3} px={4} pb={2}>
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <Typography variant="h6">
            {intl.formatMessage({ id: 'CAREMATRIXCPTC.RECORDTAB.TITLE' })}
          </Typography>

          {mustUpdate && (
            <Chip
              label={intl.formatMessage({
                id: 'CAREMATRIXCPTC.RECORDTAB.TITLETAG',
              })}
              variant="filled"
              color="warning"
            />
          )}
        </Box>

        <Typography variant="body2">
          {intl.formatMessage({ id: 'CAREMATRIXCPTC.RECORDTAB.SUBTITLE' })}
        </Typography>
      </Box>

      {hasRecords && (
        <Box
          bgcolor="white"
          pt={3}
          pb={4}
          px={4}
          display="flex"
          flexDirection="column"
          gap={2}
        >
          {records?.questions.map(record => {
            return <RecordItem key={record.id} {...record} />;
          })}
        </Box>
      )}

      {!hasRecords && (
        <Box
          bgcolor="white"
          pt={3}
          pb={4}
          px={4}
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={1}
        >
          <RecordIcon />
          <Typography variant="body1">
            {intl.formatMessage({
              id: 'CAREMATRIXCPTC.EMPTYSTATES.NOREGISTERED',
            })}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
